import { generateApiActions } from './action-helpers';

const types = {
  FETCH_COMMENTS: 'FETCH_COMMENTS',
  CREATE_COMMENT: 'CREATE_COMMENT',
  UPDATE_COMMENT: 'UPDATE_COMMENT',
  DELETE_COMMENT: 'DELETE_COMMENT',
};

export const {
  createCommentRequest,
  createCommentSuccess,
  createCommentFailure,
} = generateApiActions(types.CREATE_COMMENT);

export const {
  updateCommentRequest,
  updateCommentSuccess,
  updateCommentFailure,
} = generateApiActions(types.UPDATE_COMMENT);

export const {
  deleteCommentRequest,
  deleteCommentSuccess,
  deleteCommentFailure,
} = generateApiActions(types.DELETE_COMMENT);

export const {
  fetchCommentsRequest,
  fetchCommentsSuccess,
  fetchCommentsFailure,
} = generateApiActions(types.FETCH_COMMENTS);



// WEBPACK FOOTER //
// ./src/redux/actions/comments.js